// extracted by mini-css-extract-plugin
module.exports = {"threeColumnBookmarks":"styles_threeColumnBookmarks__3rBH2"};